<template>
  <section class="hdf-video-section03">
    <div class="video-inner">
      <!-- 视频网格：只渲染当前页，避免全量 DOM 导致的滚动卡顿 -->
      <div class="video-grid" v-if="pagedList.length > 0">
        <div
          class="video-card"
          v-for="item in pagedList"
          :key="item.id"
          @click="handleVideoClick(item)"
        >
          <div class="video-cover">
            <img :src="item.img" :alt="item.name" loading="lazy" />
            <div class="play-mask">
              <svg viewBox="0 0 24 24" width="44" height="44" fill="currentColor">
                <path d="M8 5.5v13l11-6.5z" />
              </svg>
            </div>
          </div>
          <div class="video-caption">{{ item.name }}</div>
        </div>
      </div>
      <div v-else class="video-empty">暂无视频</div>

      <!-- 分页（Element Plus） -->
      <el-pagination
        v-if="total > 0"
        class="video-pagination"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handlePageChange"
      />
    </div>

    <!-- 视频播放器弹窗 -->
    <el-dialog
      v-model="playDialogVisible"
      title="视频播放器"
      width="770"
      :before-close="handleClose"
      append-to-body
      class="video-dialog"
    >
      <div class="video-container">
        <video
          v-if="videoUrl"
          :src="videoUrl"
          controls
          autoplay
          style="width: 100%; height: auto; max-height: 70vh; object-fit: contain;"
          @contextmenu.prevent
          controlsList="nodownload"
        ></video>
        <p v-else>请提供视频链接</p>
      </div>
      <template #footer>
        <el-button @click="handleClose">关闭</el-button>
      </template>
    </el-dialog>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { apiGetIndexVideoList, apiGetIndexVideoPlayUrl } from '@/api/index'

// ===================== 数据 =====================
const videoList = ref([])
const currentPage = ref(1)
const pageSize = 8 // 4列 x 2行

const total = computed(() => videoList.value.length)

// 只取当前页数据渲染（老组件是全页渲染 + v-show 隐藏，图片多时会卡）
const pagedList = computed(() => {
  const start = (currentPage.value - 1) * pageSize
  return videoList.value.slice(start, start + pageSize)
})

const getVideoList = () => {
  apiGetIndexVideoList().then(response => {
    const res = response.data
    if (res.code == 200 && res.data) {
      videoList.value = res.data
    }
  })
}

const handlePageChange = (page) => {
  currentPage.value = page
}

// ===================== 播放弹窗 =====================
const playDialogVisible = ref(false)
const videoUrl = ref('')

const handleVideoClick = (item) => {
  apiGetIndexVideoPlayUrl({ id: item.id }).then(response => {
    const res = response.data
    if (res.code == 200) {
      videoUrl.value = res.data
      playDialogVisible.value = true
    }
  })
}

const handleClose = () => {
  playDialogVisible.value = false
  videoUrl.value = ''
}

onMounted(() => {
  getVideoList()
})
</script>

<style scoped>
/* 视频区：页宽的 80%，左右居中 */
.hdf-video-section03 {
  width: 100%;
}
.video-inner {
  width: 80%;
  margin: 0 auto;
}

/* 网格：4列，间距统一 */
.video-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
.video-card {
  cursor: pointer;
  border-radius: 16px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(31, 43, 91, 0.08);
  transition: box-shadow 0.25s ease;
}
/* 用阴影代替 transform 缩放，避免整页 scale 容器内重绘卡顿 */
.video-card:hover {
  box-shadow: 0 10px 28px rgba(31, 43, 91, 0.18);
}
.video-cover {
  height: 390px;
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #eef0f8;
  overflow: hidden;
}
.video-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.play-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: rgba(31, 43, 91, 0);
  opacity: 0;
  transition: opacity 0.25s ease, background 0.25s ease;
}
.video-card:hover .play-mask {
  opacity: 1;
  background: rgba(31, 43, 91, 0.35);
}
.video-caption {
  padding: 14px 16px;
  font-size: 16px;
  color: #1f2b5b;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.video-empty {
  padding: 60px 0;
  text-align: center;
  color: #8a91ad;
  font-size: 16px;
}

/* 分页 */
.video-pagination {
  margin-top: 36px;
  justify-content: center;
}

/* 弹窗 */
.video-dialog :deep(.el-dialog__body) {
  padding-top: 10px;
}
.video-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
